import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, memo } from 'react';
import { TableCell } from '../TableCell';
const TableRowFC = ({ rowId, row, isReadOnly, columns, errors, noBg, onValueChange }) => {
    const handleValueChange = (propertyName, newValue) => {
        const newRowVal = {
            ...row.value,
            [propertyName]: newValue
        };
        onValueChange?.(rowId, newRowVal, row.value);
    };
    return (_jsx(Fragment, { children: columns.map((col, columnId) => (_jsx(TableCell, { column: col, rowId: rowId, rowKey: row.key ?? rowId, noBg: noBg, rowValue: row.value, rowConfig: row.config, isReadOnly: isReadOnly, isFirst: columnId === 0, isLast: columnId === columns.length - 1, isInvalid: (col.propertyName &&
                (row.config?.required || col.required) &&
                !row.value[col.propertyName]) ||
                errors?.[rowId]?.[col.propertyName], onValueChange: (newValue) => {
                if (!col.propertyName) {
                    return;
                }
                handleValueChange(col.propertyName.toString(), newValue);
            } }, columnId + '_' + (row.key ?? rowId)))) }));
};
export const TableRow = memo(TableRowFC);
//# sourceMappingURL=TableRow.js.map